import { t } from 'i18next';
import { MenuDropdown, MenuDropdownItem } from '../../components/popup/MenuDropdown';
import { FILTERED_MENU } from '../constants/filteredMenu';

interface FilterMenuDropdownProps {
  selectedMenu: string;
  setSelectedMenu: (menu: string) => void;
  setIsMenuDropdownOpen: (isOpen: boolean) => void;
}

const FilterMenuDropdown = ({
  selectedMenu,
  setSelectedMenu,
  setIsMenuDropdownOpen
}: FilterMenuDropdownProps) => {
  return (
    <MenuDropdown
      onClick={() => setIsMenuDropdownOpen(false)}
      className="h-[123px] absolute top-[30px] right-0 w-[100px] z-10"
    >
      <MenuDropdownItem
        isActive={selectedMenu === FILTERED_MENU.ALL}
        onClick={() => {
          setSelectedMenu(FILTERED_MENU.ALL);
          setIsMenuDropdownOpen(false);
        }}
      >
        {t('NewTradingPhotoCardMarket.filterMenu.all')}
      </MenuDropdownItem>
      <MenuDropdownItem
        isActive={selectedMenu === FILTERED_MENU.ONGOING}
        onClick={() => {
          setSelectedMenu(FILTERED_MENU.ONGOING);
          setIsMenuDropdownOpen(false);
        }}
      >
        {t('NewTradingPhotoCardMarket.filterMenu.ongoing')}
      </MenuDropdownItem>
      <MenuDropdownItem
        isActive={selectedMenu === FILTERED_MENU.COMPLETED}
        onClick={() => {
          setSelectedMenu(FILTERED_MENU.COMPLETED);
          setIsMenuDropdownOpen(false);
        }}
      >
        {t('NewTradingPhotoCardMarket.filterMenu.completed')}
      </MenuDropdownItem>
    </MenuDropdown>
  );
};

export default FilterMenuDropdown;
